import { InjectionToken } from '@angular/core';
import type { Signal } from '@angular/core';
import type { Activity } from '@go-modules/interfaces/activity';
import type { OrgSettings } from '@go-modules/interfaces/groups/org-settings';
import type { Task, TaskType } from '@go-modules/interfaces/task';
import type { ENVIRONMENTS, LTI_ENVIRONMENT_MODES } from '@go-modules/services/environment-vars/environments';

export type ActivityEditorEnvironmentName = ENVIRONMENTS | 'library';

export interface ActivityEditorEnvironment {
	name: ActivityEditorEnvironmentName;
	mode?: LTI_ENVIRONMENT_MODES;
}

export interface AdditionalSettingsValidator {
	taskType?: TaskType;
	validateAdditionalSettingsForm(): boolean;
	focusFirstInvalidField?(): void;
}

export interface ActivityEditorContext {
	readonly activity: Signal<Activity | null>;
	readonly tasks: Signal<Task[]>;
	readonly selectedTaskType: Signal<TaskType | null>;
	readonly selectedTask: Signal<Task | null>;
	readonly isEditMode: Signal<boolean>;
	readonly isSaving: Signal<boolean>;
	readonly isDirty: Signal<boolean>;
	readonly group?: Signal<unknown | null>;
	readonly account?: Signal<unknown | null>;
	readonly org?: Signal<unknown | null>;
	readonly license?: Signal<unknown | null>;
	readonly orgSettings?: Signal<Partial<OrgSettings> | null>;
	readonly environment?: Signal<ActivityEditorEnvironment | null>;
	readonly showMasterActivityToggle: Signal<boolean>;
	readonly isActivityNameReadonly?: Signal<boolean>;
	selectTask(type: TaskType): void;
	updateActivity(activity: Activity): void;
	updateTask(task: Task): void;
	updateTasks(tasks: Task[]): void;
	openTaskList?(): void;
	registerAdditionalSettingsValidator(validator: AdditionalSettingsValidator): void;
	validateAdditionalSettings(): boolean;
	requestSaveAndClose(): void;
	requestCancel(): void;
	queueFocusCallback(callback: () => void): void;
}

export const ACTIVITY_EDITOR_CONTEXT = new InjectionToken<ActivityEditorContext>('ActivityEditorContext');
